export default __webpack_public_path__ + "static/media/logo-white.59d5483d.svg";